import BaseElement from '@theme/base-element'
import { WithShopifyCartClientMixin } from '@theme/mixin-with-shopify-cart'
import { html, nothing } from '@theme/vendor-lit'

export class CartTotal extends WithShopifyCartClientMixin(BaseElement) {
  static get properties() {
    return {
      translation: { type: Object },
    }
  }

  translation = {}

  get translatedCartCount() {
    return this.translation?.cart_count || '###count### items in your cart'
  }

  render() {
    return html`
      ${
        this.cart.item_count > 99
          ? nothing
          : html`
              <span aria-hidden="true" class="font-primary text-xs font-light"
                >${this.cart.item_count}</span
              >
            `
      }
      <span class="sr-only"
        >${this.translatedCartCount.replace(
          '###count###',
          String(this.cart.item_count)
        )}</span
      >
    `
  }
}

window.customElements.define('cart-total', CartTotal)
